// extracted by mini-css-extract-plugin
export default {"routeName":"TrainAutoCompleteResult_routeName__MJ0lf"};